module.exports = __webpack_public_path__ + "media/src/assets/Images/message-text-circle-01-99af5a32c445e6a872425faec7fa263b.svg";